<script>
import { Doughnut, mixins } from "vue-chartjs";

const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ["options"], //eslint-disable-line
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/util/doughnutChart.vue